<template>
    <div id="shoppingCart" :style="($route.query.noNavBar==='true')?{'padding-bottom': '110px'}:{}">
      <div class="navBar" id="navBar">
          <img src="~img/common/fanhui.png" class="van-search-back" alt="" @click="$router.back()" v-if="$route.query.noNavBar==undefined?false:true">
          <h2>商城购物车</h2>
          <div @click="shoppingDel()"><van-icon name="delete" /><p>删除</p></div>
      </div>
      <van-tabs swipeable animated sticky v-model="active" title-active-color="#EB5435" color="#EB5435">
          <!-- 不同平台的购物车 -->
          <van-tab :title="n.title" v-for="(n, i) in tabList" :key="i">
            <div class="tabContent" :style="'min-height:'+contentHeight+'px;'">
              <!-- 平台下的商店 -->
              <div class="contentRight" v-for="(item,index) in n.list" :key="index">
                <div class="contentRight-hd">
                  <van-icon name="shop-o" class="contentRight-hd-icon" />
                  <span class="contentRight-hd-text" @click="$router.push('/bfMerchantsShop?businessNumber='+item.businessNumber+'&&businessProperty='+n.businessProperty)">{{ item.businessName }}</span>
                </div>
                <!-- 商店商品列表 -->
                <div class="contentCard" v-for="(val,key) in item.products" :key="key">
                    <van-checkbox
                        v-if="val.isEffect===1"
                      checked-color="#EB5435"
                      :value="n.checkedList.findIndex(item => item === val.productId) !== -1"
                      @click="shopCheck(i, val.productId, item.businessNumber)"></van-checkbox>
                    <div class="checkboxDis van-checkbox" v-else><p>失效</p></div>
                    <van-card @click-thumb="$router.push(`/goodsDetail/${val.productId}`)" :thumb="getFirstImg(val.productImage)">
                        <template #origin-price v-if="val.discountPrice!=null">
                            <div class="van-card__origin-price">¥{{val.standardPrice}}</div>
                        </template>
                        <template #price>
                            <div><span class="van-card__price-currency">¥</span><span class="van-card__price-integer">{{val.discountPrice==null?val.standardPrice:val.discountPrice}}</span></div>
                        </template>
                        <template #title>
                            <p class="cardTitle">{{ val.productName }}</p>
                        </template>
                        <template #desc v-if="val.isOpenCredit===1&&n.businessProperty!==2">
                            <p class="cardDesc">￥{{ val.creditProductPrice || 0 }}+{{ val.needCredit || 0 }}积分</p>
                        </template>
                        <template #num v-if="val.isEffect===1">
                            <van-stepper
                              integer
                              class="cardNum"
                              disable-input
                              @plus="handleNum(i, 1, val)"
                              @minus="handleNum(i, -1, val)"
                              :disable-plus="val.addState"
                              v-model="val.productNum" />
                        </template>
                    </van-card>
                  </div>
              </div>
              <div class="contentRight">
              <!-- 失效商品 -->
                <div class="contentRight-hd" v-if="n.loseEffectList.length!=0">
                  <van-icon name="shop-o" class="contentRight-hd-icon" />
                  <span class="contentRight-hd-text">失效商品</span>
                  <p style="float:right;color:#939393;" @click="loseEffectDel(true)">清空失效商品</p>
                </div>
                <!-- 失效商品列表 -->
                <div class="contentCard" v-for="(val,key) in n.loseEffectList" :key="key">
                    <div class="checkboxDis van-checkbox"><p>失效</p></div>
                    <van-card @click-thumb="$router.push(`/goodsDetail/${val.productId}`)" :thumb="getFirstImg(val.productImage)">
                        <template #origin-price v-if="val.discountPrice!=null">
                            <div class="van-card__origin-price">¥{{val.standardPrice}}</div>
                        </template>
                        <template #price>
                            <div><span class="van-card__price-currency">¥</span><span class="van-card__price-integer">{{val.discountPrice==null?val.standardPrice:val.discountPrice}}</span></div>
                        </template>
                        <template #title>
                            <p class="cardTitle">{{ val.productName }}</p>
                        </template>
                        <template #desc v-if="val.isOpenCredit===1&&n.businessProperty!==2">
                            <p class="cardDesc">￥{{ val.creditProductPrice || 0 }}+{{ val.needCredit || 0 }}积分</p>
                        </template>
                        <template #num>
                            <van-button type="danger" size="mini" @click="loseEffectDel(false,val)">删除</van-button>
                        </template>
                    </van-card>
                  </div>
                </div>
            </div>
          </van-tab>
      </van-tabs>
      <van-submit-bar id="submitBar" :disabled="tabList[active].settle.isSettle==1?false:true" :button-text="`去结算（${ tabList[active].checkedList.length || 0 }）`" @submit="onSubmit" :style="($route.query.noNavBar==='true')?{'bottom': 0}:{}">
        <!-- <van-checkbox checked-color="#EB5435" v-model="checked">全选</van-checkbox> -->
        <div class="barPrice">
            <p class="barPriceP">￥{{ tabList[active].settle.realPayMoney || 0 }}&nbsp;<span class="barPriceSpan">￥{{ tabList[active].settle.handleMoney || 0 }}</span></p>
            <p class="barPriceP_">另需配送费{{ tabList[active].settle.sendMoney || 0 }}元</p>
        </div>
          <template v-if="tabList[active].settle.discountTopic" #tip>
              {{ tabList[active].settle.discountTopic }}
          </template>
      </van-submit-bar>
    </div>
</template>

<script>
import Scroll from '@/config/scroll';
import Cart from '@/config/shopCart';
import baseUrl from '@/config/baseUrl';
import { mapActions } from 'vuex';
export default {
    name: 'ShoppingCart',
    mixins: [Scroll,Cart],
    data() {
        return {
            active: 0,
            checked: false,
            shoppingNum:5,
            baseUrl,
            contentHeight:0,
            tabList: [
                {
                    title: '物业自营',
                    list: [],
                    checkedList: [],
                    businessNumber: '',//当前选中的商家编号
                    businessProperty: 3,
                    settle: {isSettle:-1},
                    loseEffectList:[]
                },
                {
                    title: '周边商家',
                    list: [],
                    checkedList: [],
                    businessNumber: '',//当前选中的商家编号
                    businessProperty: 4,
                    settle: {isSettle:-1},
                    loseEffectList:[]
                },
                {
                    title: '缤纷精选',
                    list: [],
                    checkedList: [],
                    businessNumber: '',//当前选中的商家编号
                    businessProperty: 2,
                    settle: {isSettle:-1},
                    loseEffectList:[]
                }
            ]
        };
    },
    methods: {
        ...mapActions('confirmOrder', {
            setOrderParams: 'setOrderParamsAction'
        }),
        //购物车过滤，不同平台的购物车
        cartDataFilter(data, target) {
            let arr = [],
                dataMap = data.shopCartMap,
                loseEffect = [],
                loseEffectDataMap = data.loseEffectShopCartMap;
            for(let key in dataMap) {
                let obj = {};
                obj.businessNumber = key.split(':')[0];
                obj.businessName = key.split(':')[1];
                obj.products = dataMap[key];
                arr.push(obj);
            }
            for(let key in loseEffectDataMap) {
                let obj = {};
                obj.businessNumber = key.split(':')[0];
                obj.businessName = key.split(':')[1];
                obj.products = loseEffectDataMap[key];
                for(let item in obj.products){
                    loseEffect.push({...obj.products[item],businessNumber:key.split(':')[0]});
                }
            }
            this.tabList[target].list = arr;
            this.tabList[target].loseEffectList = loseEffect;
        },
        getFirstImg(s) {
            let arr = s.split(',');
            return arr.length ? baseUrl.imgUrl + arr[0] : '';
        },
        //商品复选框事件
        shopCheck(index, productId, businessNumber) {
            let data = this.tabList[index];
            //判断当前商品跟已选商品是否为同一商家
            if(data.businessNumber !== businessNumber) {
                data.checkedList = [];
                if(data.businessNumber) {
                    this.$toast('每次只能选择一个商家的商品');
                }
                data.businessNumber = businessNumber;
            }
            //商品选中/取消选中
            if(data.checkedList.findIndex(item => item === productId) === -1) {
                data.checkedList.push(productId);
            }else {
                data.checkedList = data.checkedList.filter(item => item !== productId);
            }
            //如果有商品选中则结算
            if(data.checkedList.length) {
                this.setCartSettle(index);
            }else {
                data.settle = {};
            }
        },
        //商品数量变更事件
        handleNum(index, type, item){
            if(type===-1){
                item.addState = false;
            }
            this.updateCart({
                productId: item.productId,
                productNum: type
            }).then((res) => {
                if(this.tabList[index].checkedList.findIndex(n => n === item.productId) !== -1) {
                    this.setCartSettle(index);
                }
                this.$toast(res.msg);
            }).catch((res) => {
                item.productNum -= 1;
                item.addState = true;
                this.$toast(res.error);
            });
        },
        //商品结算获取
        setCartSettle(index) {
            const { businessProperty, businessNumber, checkedList } = this.tabList[index];
            this.settleCart({
                businessProperty,
                businessNumber,
                productIds: checkedList.join(',')
            }).then((res) => {
                this.tabList[index].settle = res.data;
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        shoppingDel() {
            this.$dialog.confirm({
                title: '提示',
                message: '您确定要删除已选商品吗？'
            }).then(() => {
                this.deltCart();
            });
        },
        loseEffectDel(flug,rows) {
            this.$dialog.confirm({
                title: '提示',
                message: flug?'您确定要清空失效商品吗？':'您确定要删除该失效商品吗？'
            }).then(() => {
                let data = this.tabList[this.active],
                    params = {
                        businessProperty: data.businessProperty
                    };
                if(flug){
                    data.loseEffectList.forEach((item, index) => {
                        params[`cartList[${index}].businessNumber`] = item.businessNumber;
                        params[`cartList[${index}].productId`] = item.productId;
                    });
                }else{
                    params['cartList[0].businessNumber'] = rows.businessNumber;
                    params['cartList[0].productId'] = rows.productId;
                }
                this.deleteCart(params).then((res) => {
                    //重新拉取购物车
                    this.getCartList({ businessProperty: data.businessProperty }).then((_data) => {
                        this.cartDataFilter(_data.data, this.active);
                    });
                    this.$toast(res.msg);
                }).catch((res) => {
                    this.$toast(res.error);
                });
            });
        },
        deltCart() {
            let data = this.tabList[this.active],
                params = {
                    businessProperty: data.businessProperty
                };
            data.checkedList.forEach((item, index) => {
                params[`cartList[${index}].businessNumber`] = data.businessNumber;
                params[`cartList[${index}].productId`] = item;
            });
            this.deleteCart(params).then((res) => {
                //重新拉取购物车
                this.getCartList({ businessProperty: data.businessProperty }).then((_data) => {
                    this.cartDataFilter(_data.data, this.active);
                });
                //重新结算
                // this.setCartSettle(this.active);
                this.tabList[this.active].settle = {};
                //拉取购物车总数量
                this.getCartNum();
                //清空已选商品
                this.tabList[this.active].checkedList = [];
                this.$toast(res.msg);
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        onSubmit(){
            let data = this.tabList[this.active];
            if(!data.checkedList.length) {
                this.$toast('请选择要结算的商品');
                return;
            }
            this.setOrderParams({
                productIds: data.checkedList.join(','),
                businessProperty: data.businessProperty,
                businessNumber: data.businessNumber
            });
            this.$router.push('/confirmOrder');
        }
    },
    created() {
        //获取每个平台购物车信息
        this.getCartList({ businessProperty: 2 }).then((res) => {
            this.cartDataFilter(res.data, 2);
        });
        this.getCartList({ businessProperty: 3 }).then((res) => {
            this.cartDataFilter(res.data, 0);
        });
        this.getCartList({ businessProperty: 4 }).then((res) => {
            this.cartDataFilter(res.data, 1);
        });
        //拉取购物车总数量
        this.getCartNum();
    },
    mounted() {
        this.contentHeight = document.body.clientHeight - document.getElementById('navBar').offsetHeight - document.getElementById('submitBar').offsetHeight - document.getElementsByClassName('van-tabs__nav van-tabs__nav--line')[0].offsetHeight*2 - document.getElementsByClassName('van-hairline--top-bottom')[0].offsetHeight;
    }
};
</script>
<style lang="scss">
    #shoppingCart{
      padding-bottom: 130px;
      .van-submit-bar{
        bottom: 1.333333rem;
        transform: translateZ(0);
        .van-submit-bar__bar{
          padding-right: 0;
        }
        .van-button{
          border-radius:0;
          height: 100%;
          background: #EB5435;
        }
        .barPrice{
              -webkit-box-flex: 1;
              -webkit-flex: 1;
              flex: 1;
              padding-right: 0.32rem;
              color: #323233;
              text-align: right;
              .barPriceP{
                font-size:18px;
                font-family:PingFang SC;
                font-weight:bold;
                color:rgba(232,91,77,1);
                line-height:28px;
              }
              .barPriceP_{
                font-size:12px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(141,141,141,1);
                line-height:14px;
              }
              .barPriceSpan{
                font-size:14px;
                font-family:PingFang SC;
                font-weight:500;
                text-decoration:line-through;
                color:rgba(178,176,176,1);
                line-height:14px;
              }
        }
      }
      .navBar{
        text-align: center;
        position: relative;
        background: #fff;
        overflow: hidden;
        h2{
          font-size:18px;
          font-family:PingFang SC;
          font-weight:bold;
          color:rgba(0,0,0,1);
          line-height:20px;
        }
        div{
          position:absolute;
          right: 18px;
          top: 15px;
          font-size:14px;
          font-family:PingFang SC;
          color:#939393;
          .van-icon{
            margin-right: 2px;
            font-size:17px;
            float: left;
          }
          p{
            display: inline-block;
          }
        }
        .van-search-back {
            padding: 0 15px;
            width: 12px;
            position: absolute !important;
            left: 0 !important;
            top: 15px !important;
        }
      }
      .tabContent{
        padding:15px 12px;
      }
      .contentRight {
        border-radius:8px;
      background: #fff;
      margin-bottom: 10px;
      .contentRight-hd {
        padding: 10px 15px;
        .contentRight-hd-icon {
          font-size: 15px;
          vertical-align: middle;
        }
        .contentRight-hd-text {
          color: #000000;
          font-size: 15px;
          font-weight: bold;
          vertical-align: middle;
          margin-left: 5px;
        }
      }
      .contentCard:last-child{
        border-bottom:none;
      }
      .contentCard{
          border-bottom: 1px solid #E5E5E5;
          padding: 15px 0;
          margin: 0 10px;
          .van-checkbox{
            float: left;
            margin-top: 30px;
          }
          .checkboxDis{
              width: 35px;
              height:18px;
              font-size:12px;
              font-family:PingFang SC;
              font-weight:500;
              color:#fff;
              line-height:18px;
              text-align: center;
              background:rgba(135,135,135,1);
              border-radius:18px;
              margin-right: 5px;
              p{
                margin: 0 auto;
              }
          }
          .boxOpacity{
            opacity:0.67;
          }
        .van-card{
          padding:0;
          margin:0 0 0 30px;
          background: bottom;
          text-align: left;
          .cardTitle{
              font-size:15px;
              font-family:PingFang SC;
              font-weight:bold;
              color:rgba(51,51,51,1);
              line-height:20px;
              white-space: nowrap;
              text-overflow:ellipsis;
              overflow:hidden;
              margin-bottom: 10px;
          }
          .cardDesc{
            font-size:15px;
            font-family:PingFang SC;
            font-weight:bold;
            color:rgba(232,91,77,1);
            line-height:15px;
          }
          .van-card__price{
              color: #E85B4D;
          }
          .cardNum{
              float: right;
          }
          .van-card__thumb img{
              border-radius:0px;
          }
        }
      }
    }
    }
</style>
